import { Component, OnInit } from '@angular/core';

@Component({
    moduleId: module.id,
    selector: 'defaultcomponent',
    templateUrl: 'defaultcomponent.component.html'
})
export class DefaultComponent{
}
